import script from "./ModalMain.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalMain.vue?vue&type=script&setup=true&lang=js"

import "./ModalMain.vue?vue&type=style&index=0&id=196df28b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-196df28b"]])

export default __exports__